var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectedAccountsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.7998C6.67437 12.7998 5.4744 12.2623 4.6056 11.3942L6.4 9.5998H1.6V14.3998L3.4744 12.5254C4.63253 13.6835 6.23248 14.3998 8 14.3998C11.5344 14.3998 14.4 11.5348 14.4 7.9998H12.8C12.8 10.651 10.6512 12.7998 8 12.7998V12.7998Z",
    fill: "#2A2D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.6C4.4656 1.6 1.6 4.46496 1.6 8H3.2C3.2 5.3488 5.3488 3.2 8 3.2C9.32563 3.2 10.5256 3.7375 11.3944 4.60563L9.6 6.40003H14.4V1.60003L12.5256 3.47443C11.3675 2.3163 9.76752 1.60003 8 1.60003V1.6Z",
    fill: "#2A2D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedAccountsIcon);
export default __webpack_public_path__ + "static/media/connected-accounts-icon.e65226eab88854f5508a4f02656701ae.svg";
export { ForwardRef as ReactComponent };